import {Divider, Tooltip, Typography} from "@material-ui/core";
import React from "react";
import {SuggestedAvailability} from "../redux/types";
import {FindAvailabilityStepProps, SetStepDataType} from "../types";
import {OrderEngineStepActions} from "./OrderEngineStepActions";
import {MobileSuggestedAvailabilities} from "./MobileSuggestedAvailabilities";
import {InfoOutlined} from "@material-ui/icons";

interface SuggestedAvailabilitiesStepProps extends FindAvailabilityStepProps<SetStepDataType> {
    suggestAvailabilities: SuggestedAvailability[];
    loading: boolean;
    servicesIds: string[];
    fetchSuggestedAvailabilities: (from: number, to: number) => void;
    isDesktop: boolean;
}

export function SuggestedAvailabilitiesStep({
                                                suggestAvailabilities,
                                                loading,
                                                servicesIds,
                                                onNext,
                                                onBack,
                                                fetchSuggestedAvailabilities
                                            }: SuggestedAvailabilitiesStepProps) {

    return (
        <div>
            <Typography color={"textSecondary"} style={{display: 'inline-flex', alignItems: "center"}}>
                Wählen Sie einen Termin aus <Tooltip title={<Typography>Anhand Ihrer Eingaben wurden verfügbare Gartenhilfen ermittelt. Bitte wählen Sie eine Gartenhilfe aus der folgenden Liste aus und geben die geschätzte Zeit ein, die Sie die Hilfe benötigen. .</Typography>}><InfoOutlined style={{marginLeft: 8, textAlign: "center"}} color="primary" fontSize="small"/></Tooltip>
            </Typography>
            <Divider style={{marginBottom: 16, marginTop: 8}}/>
            {/*{isDesktop*/}
            {/*    ? (*/}
            {/*        <ClientCalendar*/}
            {/*            suggestedAvailabilities={suggestAvailabilities}*/}
            {/*            servicesIds={servicesIds}*/}
            {/*            onConfirm={onNext}*/}
            {/*            loading={loading}*/}
            {/*            fetchSuggestedAvailabilities={fetchSuggestedAvailabilities}*/}
            {/*        />*/}
            {/*    )*/}
            {/*    : (*/}
            {/*       <MobileSuggestedAvailabilities*/}
            {/*           suggestedAvailabilities={suggestAvailabilities}*/}
            {/*           servicesIds={servicesIds}*/}
            {/*           onConfirm={onNext}*/}
            {/*           loading={loading}*/}
            {/*           fetchSuggestedAvailabilities={fetchSuggestedAvailabilities}*/}
            {/*       />*/}
            {/*    )*/}
            {/*}*/}
            <MobileSuggestedAvailabilities
                suggestedAvailabilities={suggestAvailabilities}
                servicesIds={servicesIds}
                onConfirm={onNext}
                loading={loading}
                fetchSuggestedAvailabilities={fetchSuggestedAvailabilities}
            />
            <OrderEngineStepActions lastStep={false} onClickBack={onBack}/>
        </div>
    )
}
